import React, { Fragment, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { scrollUpPage, updateProductGridColumns } from "src/_utils/elements";
import { CSS } from "src/_utils/styles";
import { getQueryParams } from "src/_utils/urls";
import { Btn, H6, Image, LI, P, UL } from "src/AbstractElements";
import { EBSSSPagination } from "src/base/atoms/EBSSSPagination";
import { useEBSSS } from "src/base/context/EBSSSContext/useEBSSS";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import Page from "src/base/Page";
import { remotePath } from "src/base/settings/Paths";
import { Category, SkeletonLoader } from "../Products/ProductsCommon";
import { Card, CardBody, CardHeader, Col, Container, Form, Input, InputGroup, InputGroupText, Label, Modal, ModalHeader, Row } from "reactstrap";
import { ChevronDown } from "react-feather";
import { ReduxDataKey } from "src/base/store/store";
import { useSelector } from "react-redux";
import { Session } from "src/base/store/authSlice";
import { SellersFeatures, SellersGrid } from "./SellersCommon";

const SellersListPage = () => {
  const { trans } = useEBSSSLayout();
  const { sellersList, loaded, appSettings, apiErrors, fetchSellersList, fetchSellersCategoryList } = useEBSSS();
  const sessionNow: Session = useSelector((state) => state[ReduxDataKey.AUTH]);
  const [page, setPage] = useState(null);
  const [ordering, setOrdering] = useState(null);
  const [sortBy, setSortBy] = useState(null);
  const getCategory = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let actualParams = getQueryParams(window.location.href);
    if (actualParams?.page) {
      setPage((p) => {
        if (p !== null) {
          return p;
        } else {
          return Number(actualParams?.page);
        }
      });
    }
  }, [window.location.search]);

  useEffect(() => {
    scrollUpPage();
    if (sellersList?.sellers?.data) {
      if (page && page > 0) {
        fetchSellersCategoryList({ page }, Number(getCategory?.category));
      }
    }
  }, [page]);

  useEffect(() => {
    scrollUpPage();
    let actualParams = getQueryParams(window.location.href);
    if (!sellersList?.sellers?.data) {
      fetchSellersCategoryList({ page: actualParams?.page }, Number(getCategory?.category));
    }
  }, []);

  useEffect(() => {
    if (!sessionNow?.user?.id && apiErrors && !apiErrors?.public_products) {
      navigate(`${process.env.PUBLIC_URL}/auth/sign-in`);
    }
  }, [apiErrors]);

  console.log(sellersList);

  return (
    <Page breads={[{ name: trans("website.sellers") + (sellersList?.category?.title ?? ""), active: true }]}>
      <Fragment>
        <Container fluid={true} className="product-wrapper">
          <div className="product-grid mb-3">
            <SellersFeatures categories={sellersList?.categories?.data} sortBy={sortBy} setSortBy={setSortBy} />
            {!loaded ? (
              <div className="d-flex flex-row flex-wrap">
                <SkeletonLoader isLoading={!loaded} />
              </div>
            ) : (
              <SellersGrid perLine={4} data={sellersList?.sellers?.data} trans={trans} sortBy={""} />
            )}
            <EBSSSPagination page={page} data={{ ...sellersList?.sellers, data: sellersList?.sellers?.data }} />
          </div>
        </Container>
      </Fragment>
    </Page>
  );
};

export default SellersListPage;
